import { render, staticRenderFns } from "./NewestsCard.vue?vue&type=template&id=5d92206b&"
import script from "./NewestsCard.vue?vue&type=script&lang=js&"
export * from "./NewestsCard.vue?vue&type=script&lang=js&"
import style0 from "./NewestsCard.vue?vue&type=style&index=0&id=5d92206b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports